import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {environment} from '../../../environments/environment';
import {NavCode} from '../../models/staff/navcode';
import {Message} from '../../models/danhmuc/message';
const apiUrl = `${environment.apiUrl}/api/staff/navcode`;

@Injectable({
  providedIn: 'root'
})
export class NavCodeService {
  constructor(public httpService: HttpClient) { }


  findALlByStaffId(staffId: number): Observable<NavCode[]> {
    return this.httpService.get<NavCode[]>(`${apiUrl}/getallbystaffid?stid=${staffId}`).pipe(
      map(data => data.map(data => new NavCode().deserialize(data)))
    );
  }
  findALlByNavId(navId: number): Observable<NavCode[]> {
    return this.httpService.get<NavCode[]>(`${apiUrl}/getallbynavid?nid=${navId}`).pipe(
      map(data => data.map(data => new NavCode().deserialize(data)))
    );
  }
  findAllByCode(code : string): Observable<NavCode[]> {
    return this.httpService.get<NavCode[]>(`${apiUrl}/getallbycode?code=${code}`).pipe(
      map(data => data.map(data => new NavCode().deserialize(data)))
    );
  }
  public addMulti(code: string, ids: string): Observable<Message>
  {
    return this.httpService.get<Message>(`${apiUrl}/addmulti?code=${code}&ids=${ids}`).pipe(
      map(data => new Message().deserialize(data)),
      catchError(() => throwError('insert error'))
    );
  }
}
